module.exports = __webpack_public_path__ + "static/media/bg-dashboard.f944b188.png";